import React, { Component } from 'react';
import Tooltip from '../tooltip';
import Icon from '../icon';
import Button from '../button';
import LocaleReceiver from '../locale-provider/LocaleReceiver';
import defaultLocale from '../locale-provider/default';
import { Size } from '../_util/enum';
import ConfigContext from '../config-provider/ConfigContext';
export default class Popconfirm extends Component {
    constructor(props) {
        super(props);
        this.onConfirm = e => {
            this.setVisible(false);
            const { onConfirm } = this.props;
            if (onConfirm) {
                onConfirm.call(this, e);
            }
        };
        this.onCancel = e => {
            this.setVisible(false);
            const { onCancel } = this.props;
            if (onCancel) {
                onCancel.call(this, e);
            }
        };
        this.onVisibleChange = (visible) => {
            this.setVisible(visible);
        };
        this.saveTooltip = (node) => {
            this.tooltip = node;
        };
        this.renderOverlayWithLocale = (popconfirmLocale) => {
            const { title, cancelText, okText, okType, iconType, okButtonProps, cancelButtonProps } = this.props;
            const prefixCls = this.getPrefixCls();
            return (React.createElement("div", { className: `${prefixCls}-inner-content` },
                React.createElement("div", { className: `${prefixCls}-message` },
                    React.createElement(Icon, { type: iconType }),
                    React.createElement("div", { className: `${prefixCls}-message-title` }, typeof title === 'function' ? title() : title)),
                React.createElement("div", { className: `${prefixCls}-buttons` },
                    React.createElement(Button, Object.assign({}, okButtonProps, { onClick: this.onCancel, size: Size.small }), cancelText || popconfirmLocale.cancelText),
                    React.createElement(Button, Object.assign({}, cancelButtonProps, { onClick: this.onConfirm, type: okType, size: Size.small }), okText || popconfirmLocale.okText))));
        };
        this.renderLocale = () => {
            return (React.createElement(LocaleReceiver, { componentName: "Popconfirm", defaultLocale: defaultLocale.Popconfirm }, this.renderOverlayWithLocale));
        };
        this.state = {
            visible: props.visible,
        };
    }
    static get contextType() {
        return ConfigContext;
    }
    componentWillReceiveProps(nextProps) {
        if ('visible' in nextProps) {
            this.setState({ visible: nextProps.visible });
        }
    }
    getPopupDomNode() {
        return this.tooltip.getPopupDomNode();
    }
    setVisible(visible) {
        const props = this.props;
        if (!('visible' in props)) {
            this.setState({ visible });
        }
        const { onVisibleChange } = props;
        if (onVisibleChange) {
            onVisibleChange(visible);
        }
    }
    getPrefixCls() {
        const { prefixCls } = this.props;
        const { getPrefixCls } = this.context;
        return getPrefixCls('popover', prefixCls);
    }
    render() {
        const { placement, ...restProps } = this.props;
        const { visible } = this.state;
        return (React.createElement(Tooltip, Object.assign({}, restProps, { prefixCls: this.getPrefixCls(), placement: placement, onVisibleChange: this.onVisibleChange, visible: visible, overlay: this.renderLocale, ref: this.saveTooltip })));
    }
}
Popconfirm.displayName = 'Popconfirm';
Popconfirm.defaultProps = {
    transitionName: 'zoom-big',
    placement: 'top',
    trigger: 'click',
    okType: 'primary',
    iconType: 'warning',
};
